module.exports = __webpack_public_path__ + "static/media/sp_livescore.0c16c55b.png";